function getPage(rootDir, component) {
  return () => import(`@/pages/${rootDir}/Pages/${component}.vue`)
}

export function getFrontendPage(componentName) {
  return getPage('Frontend', componentName)
}

function getBackendPage(relativeDir, componentName) {
  return getPage('Backend', `${relativeDir}/${componentName}`)
}

export function getBackendGeneralPage(componentName) {
  return getBackendPage('General', componentName)
}

export function getBackendAnualPage(componentName) {
  return getBackendPage('Anual', componentName)
}

export function getBackendAgenciesPage(componentName) {
  return getBackendPage('Agencies', componentName)
}

export function getBackendAlertsPage(componentName) {
  return getBackendPage('Alerts', componentName)
}

export function getBackendAdminPage(componentName) {
  return getBackendPage('Admin', componentName)
}

export function getDummyPage(componentName) {
  return getPage('Dummy', componentName)
}
